<template>
    <div class='content-wrapper'>
      <Breadcrumb :title="$t('personalMenu-history')" />
      <div class='content-body'>
        <div class='row'>
          <div class='col-12'>
            <section class='card'>
              <div class='card-content'>
                <div class='card-body'>
                  <TransactionHistoryList />
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import TransactionHistoryList from '../components/global/TransactionHistoryList.vue';
  import Breadcrumb from '@/components/layout/Breadcrumb';
  
  export default {
    name: 'TransactionHistory',
    components: {
      TransactionHistoryList,
      Breadcrumb
    }
  };
  </script>
  
  <style scoped></style>
  